export const pagesIntroductionTranslation = {
  en: {
    "S.No": "S.No",
    "Page Key": "Page Key",
    Title: "Title",
    Description: "Description",
    "Created At": "Created At",
    Actions: "Actions",
    Edit: "Edit",
    Delete: "Delete",
    "Pages-Introductions": "Pages Introductions",
    "+ Add Page Introduction": "+ Add Page Introduction",
    "Edit Page Introduction": "Edit Page Introduction",
    "Add New Page Introduction": "Add New Page Introduction",
    "Update Page Introduction": "Update Page Introduction",
    "Add Page Introduction": "Add Page Introduction",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    "Description (EN)": "Description (EN)",
    "Description (AR)": "Description (AR)",
    "Are you sure you want to delete page '{{key}}'?":
      "Are you sure you want to delete page '{{key}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Cancel: "Cancel",
  },
  ar: {
    "S.No": "رقم",
    "Page Key": "مفتاح الصفحة",
    Title: "العنوان",
    Description: "الوصف",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    Edit: "تعديل",
    Delete: "حذف",
    "Pages-Introductions": "مقدمة الصفحات",
    "+ Add Page Introduction": "+ إضافة مقدمة صفحة",
    "Edit Page Introduction": "تعديل مقدمة الصفحة",
    "Add New Page Introduction": "إضافة مقدمة صفحة جديدة",
    "Update Page Introduction": "تحديث مقدمة الصفحة",
    "Add Page Introduction": "إضافة مقدمة صفحة",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    "Description (EN)": "الوصف (EN)",
    "Description (AR)": "الوصف (AR)",
    "Are you sure you want to delete page '{{key}}'?":
      "هل أنت متأكد أنك تريد حذف الصفحة '{{key}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Cancel: "إلغاء",
  },
};
